<div class="agpr-accountPreferences-subSection">
    @if (loaded) {
        @if (hasAccountPreferences) {
            @if (hasFinancialTimesEnabled) {
                <div
                    #section
                    id="attributions"
                    class="agpr-monitoringPreferences-attributions"
                >
                    <h4 class="agpr-accountPreferences-subSection-heading">
                        {{ 'AccountPreferences.attributions' | localize }}
                    </h4>

                    <div class="agpr-accountPreferences-subSection-content">
                        {{ 'AccountPreferences.attributions.message' | localize }}
                    </div>
                </div>
            }
            <!-- Add future sections (e.g. API Keys, Data Connections, Styles, Templates) here as their own @if block -->
        } @else {
            <agpr-message [severity]="messageSeverityEnum.noContent">
                {{ 'AccountPreferences.monitoring.noContent' | localize }}
            </agpr-message>
        }
    }
</div>
